import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { Container } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import logoBunny from "../assets/logo-bunny.png";

const Header = () => {
  // CUSTOM STYLES FOR Header
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
      fontWeight: 'bold',
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
  }));

  const classes = useStyles();
  // STUFF FOR MOBILE MENU
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMobileMenuOpen = (event: React.ChangeEvent<any>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <p><Link component={RouterLink} to="/" style={{ color: '#fff' }}>Home</Link></p>
      </MenuItem>
      <MenuItem>
        <p><Link component={RouterLink} to="/collections" style={{ color: '#fff' }}>Collections</Link></p>
      </MenuItem>
      {/* <MenuItem>
        <p><Link component={RouterLink} to="/redeem" style={{ color: '#fff' }}>Redeem</Link></p>
      </MenuItem> */}
      <MenuItem>
        <p><Link component={RouterLink} to="/help" style={{ color: '#fff' }}>Help Guide</Link></p>
      </MenuItem>
    </Menu>
  );
  // END OF STUFF FOR MOBILE MENU

  return (
    <div className={classes.root}>
      <AppBar position="static" style={{ backgroundColor: '#343548' }}>
        <Container maxWidth="lg">
          <Toolbar style={{ padding: 0 }}>
            <Typography variant="h6" className={classes.title}>
              <Link component={RouterLink} to="/" style={{ color: '#fff', textDecoration: 'none', cursor: 'hand', display: 'flex', alignItems: 'center' }}>
                <img src={logoBunny} style={{ height: '50px' }} alt="LasVegasVP" />
                <span style={{ padding: '0 10px' }}>LasVegasVP</span>
              </Link>
            </Typography>

            <div className={classes.sectionDesktop}>
              <Button size="small" color="inherit" style={{ textTransform: 'capitalize', padding: '4px 25px' }} component={RouterLink} to="/">Home</Button>
              <Button size="small" color="inherit" style={{ textTransform: 'capitalize', padding: '4px 25px' }} component={RouterLink} to="/collections">Collections</Button>
              {/* <Button size="small" color="inherit" style={{ textTransform: 'capitalize', padding: '4px 25px' }} component={RouterLink} to="/redeem">Redeem</Button> */}
              <Button size="small" color="inherit" style={{ textTransform: 'capitalize', padding: '4px 25px' }} component={RouterLink} to="/help">Help Guide</Button>
              {/* lol */}
              {/* <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                <InstagramIcon fontSize="small" />
              </IconButton>
            
              <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                <TwitterIcon fontSize="small" />
              </IconButton> */}
            </div>
            <div className={classes.sectionMobile}>
              <IconButton
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
            </div>
          </Toolbar>
        </Container>
      </AppBar>
      {renderMobileMenu}
    </div>
  );
};

export default Header;